<template>
  <div class="article-list-container">
    <div class="page-header">
      <h1 class="page-title">宣传文章</h1>
    </div>

    <div class="article-list">
      <van-skeleton :row="3" :loading="loading" v-for="i in 7" :key="'skeleton-' + i" v-if="loading">
        <template #template>
          <div class="skeleton-item">
            <div class="skeleton-title"></div>
            <div class="skeleton-content"></div>
          </div>
        </template>
      </van-skeleton>

      <template v-if="!loading">
        <van-cell
          v-for="article in articleList"
          :key="article.id"
          :title="article.title || '大云山国家森林公园景点'"
          is-link
          @click="goToDetail(article.id)"
        >
          <template #right-icon>
            <div class="article-item-image" v-if="article.image">
              <img :src="article.image" alt="文章封面">
            </div>
          </template>
        </van-cell>

        <div class="empty-state" v-if="!loading && articleList.length === 0">
          <van-empty image="search" description="暂无文章" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ArticleDao from '@/h5/doucan/network/article'
import { Cell, Skeleton, Empty, Toast } from 'vant'

export default {
  name: 'ArticleListPage',
  components: {
    'van-cell': Cell,
    'van-skeleton': Skeleton,
    'van-empty': Empty
  },
  data() {
    return {
      loading: true,
      articleList: [],
      // 要显示的文章ID列表
      articleIds: [
        'dayunshan_102',
        'dayunshan_103',
        'dayunshan_104',
        'dayunshan_105',
        'dayunshan_106',
        'dayunshan_107',
        'dayunshan_108'
      ]
    }
  },
  created() {
    this.fetchArticleList()
  },
  methods: {
    async fetchArticleList() {
      try {
        this.loading = true
        // 获取所有指定ID的文章详情
        const promises = this.articleIds.map(id => ArticleDao.getArticleDetail(id))
        const responses = await Promise.all(promises)

        // 处理响应结果，提取文章数据
        this.articleList = responses
          .filter(res => res.code === 200 && res.data)
          .map(res => {
            const article = res.data

            // 提取文章中的第一张图片作为封面
            let image = null
            if (article.content) {
              const imgMatch = article.content.match(/!\[.*?\]\((.*?)\)/)
              if (imgMatch && imgMatch[1]) {
                image = imgMatch[1]
              }
            }

            return {
              id: article.id,
              title: article.title || `大云山国家森林公园景点 ${article.id.split('_')[1]}`,
              image: image
            }
          })
      } catch (error) {
        console.error('获取文章列表失败:', error)
        Toast('获取文章列表失败')
      } finally {
        this.loading = false
      }
    },
    // 跳转到文章详情页
    goToDetail(id) {
      this.$router.push({
        path: '/h5/doucan/pages/thirdpart/dongling/article/detail',
        query: { id }
      })
    }
  }
}
</script>

<style scoped>
.article-list-container {
  padding: 16px;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 16px;
  text-align: center;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #323233;
}

.article-list {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(100, 101, 102, 0.08);
}

.article-item-image {
  width: 60px;
  height: 60px;
  margin-left: 8px;
  overflow: hidden;
  border-radius: 4px;
}

.article-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.skeleton-item {
  padding: 16px;
  border-bottom: 1px solid #f2f3f5;
}

.skeleton-title {
  height: 16px;
  margin-bottom: 8px;
  background: #f2f3f5;
  border-radius: 2px;
}

.skeleton-content {
  height: 40px;
  background: #f2f3f5;
  border-radius: 2px;
}

.empty-state {
  padding: 40px 0;
}
</style>
